import React from 'react'
import PropTypes from 'prop-types';
import { css } from '@emotion/react';
import { breakpoints } from '~styles/global'
import TextBlock from '~components/TextBlock'
import FAQList from '~components/FAQList'
import Testimonial from '~components/Testimonial'
import TextAndMediaBlock from '~components/TextAndMediaBlock'
import DoubleImageBlock from '~components/DoubleImageBlock'
import ImageBlock from '~components/ImageBlock'



const RenderBlock = ({ type, content, className, lastBlock }) => {

  const {mobile} = breakpoints

  const blockSpacingCss = `
    margin-bottom: 12rem;
    ${mobile}{
      margin-bottom: 8rem;
    }
  `
  
  switch (type) {
    case "textBlock":
      return(
        <TextBlock content={content?.text} className={className} css={css`${blockSpacingCss}`} />
      )
    case "faqBlock":
      return(
        <FAQList heading={content?.title} faqs={content?.questions} className={className} css={css`${blockSpacingCss}`}/>
      )
    case "quoteBlock":
      return(
        <Testimonial 
          stars={parseInt(content?.rating)} 
          quote={content?.quote} 
          author={content?.name} 
          location={content?.location}
          className={className}
          css={css`${blockSpacingCss}
        `}/>
      )
    case "textMediaBlock":
      return(
        <TextAndMediaBlock 
          heading={content?.title} 
          text={content?.text} 
          image={content?.image?.asset?.id} 
          video={content?.video?.asset?.url} 
          className={className}
          css={css`${blockSpacingCss}
        `}/>
      )
    case "doubleMediaBlock":
      return(
        <DoubleImageBlock 
          imageLeft={content?.imageLeft} 
          videoLeft={content?.videoLeft}
          imageRight={content?.imageRight} 
          videoRight={content?.videoRight}
          className={className}
          css={css`
            ${blockSpacingCss}
            margin-bottom: ${lastBlock ? `0rem` : `12rem`};
            ${mobile}{
              margin-bottom: ${lastBlock ? `0rem` : `8rem`};
            }
        `}/>
      )
    case "wideImageBlock":
      return(
        <ImageBlock 
          image={content?.image}
          className={className}
          aspectRatio={1.84}
          css={css`
            ${blockSpacingCss}
            margin-bottom: ${lastBlock ? `0rem` : `12rem`};
            ${mobile}{
              margin-bottom: ${lastBlock ? `0rem` : `8rem`};
            }
        `}/>
      )
    default: return null
  }
}

RenderBlock.propTypes = {
  content: PropTypes.object,
  type: PropTypes.string,
  className: PropTypes.string,
}

RenderBlock.defaultProps = {
}

export default RenderBlock
